import axios from 'axios';
import {
    HEADERS_TOKEN,
    ACTUALIZAR_EJERCICIO,
} from 'constants/routes/endpoints';

export const guardarDatosEjercicio = () => {

    return new Promise((resolve, reject) => {

        return axios({
            url: ACTUALIZAR_EJERCICIO,
            method: 'POST',
            headers: HEADERS_TOKEN,
            data: {
				usuario: encodeURIComponent(localStorage.usuarioValidarDatos),
				password: encodeURIComponent(localStorage.passValidarDatos),
				idLegajoTemporal: Number(localStorage.idLegajoTemporal)
			},
        })
            .then(response => response)
            .then(json => {

                return resolve({ data: json.data });
            })
            .catch(err => {
                var errorJson = err.toJSON();
                console.log(errorJson.config.url);
                console.log(errorJson.message);
                return resolve({ data: { mensaje: 'Por favor vuelva a intentarlo nuevamente' } });
            });
    });
};